export default {
  currentConversation: null,
  lastAnalysis: null,
  availableMetrics: [],
  currentStreamingMessage: null,
  isChatLoading: false,
};
